import '@vfde-brix/feedback/dist/styles.css';
import { createFeedbackComponent } from '@vfde-brix/feedback';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import { createComponents } from '../../utils/initComponents';

createComponents('brix-feedback', createFeedbackComponent, NO_PATTERN_BUSINESS_LOGIC);
